import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=25f03b32"
import script from "./BackToTop.vue?vue&type=script&lang=ts"
export * from "./BackToTop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports